export default {"src":"/_next/static/media/image-circle-xmark-regular-full.5e740186.svg","height":640,"width":640,"blurWidth":0,"blurHeight":0};